import { InvoiceManagementProvider, SessionManagementProvider } from '@context'
import { useExperienceManager } from '@hooks'
import React from 'react'
import { useParams } from 'react-router-dom'
import { useSessionControllerGetCompletedSessionDetailsV2 } from '~/clinician-api'
import { SessionNotesV2 } from './session-notes-v2'
import { SessionNotesV3 } from './session-notes-v3'

export function SessionNotes() {
  const { isOneClickFinalizeEnabled } = useExperienceManager()
  const { sessionId }: { sessionId: string } = useParams()

  const { data: session } = useSessionControllerGetCompletedSessionDetailsV2(
    sessionId,
    {
      query: { enabled: sessionId !== 'undefined' && isOneClickFinalizeEnabled }
    }
  )

  if (isOneClickFinalizeEnabled) {
    return (
      <InvoiceManagementProvider
        invoiceId={session?.medplumInvoiceId ?? undefined}
      >
        <SessionManagementProvider sessionId={sessionId}>
          <SessionNotesV3 />
        </SessionManagementProvider>
      </InvoiceManagementProvider>
    )
  }
  return (
    <SessionManagementProvider sessionId={sessionId}>
      <SessionNotesV2 />
    </SessionManagementProvider>
  )
}
